import script from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"

import "./MiniaturesSection.vue?vue&type=style&index=0&id=5f417b09&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f417b09"]])

export default __exports__